export const createJudgingProgrammesRequests = (client) => ({
    listJudgingProgrammes: async (params) => {
        const { data, meta, links } = await client.api.get("judging_programmes", {
            params: params,
        });
        return { data, meta, links };
    },
});
//# sourceMappingURL=index.js.map